import request from "../../utils/request";

export const getCurrLineGoodByCode = (params) => {
  return request({
    method: "GET",
    path: '/hallManagement/getCurrLineGoodByCode',
    params,
  });
};